import moment from "moment"
import { useRouter } from "vue-router";
// import { inject } from "vue";

// const basedata=inject("basedata")
function isValidEmail(val){
    const emailPattern = /^(?=[a-zA-Z0-9@._%+-]{6,254}$)[a-zA-Z0-9._%+-]{1,64}@(?:[a-zA-Z0-9-]{1,63}\.){1,8}[a-zA-Z]{2,63}$/;
    return emailPattern.test(val) || 'Invalid email';
  }
export default {

    router : null,
    name:"helpers",
    log: console.log,



    validations :{
        text:[val => (val && val.length > 0) || 'Bitte ausfüllen'],
        bool:[val => (val && val===true) || 'Bitte zustimmen'],
        email:[val => !!val || 'Email is missing', isValidEmail]
     },





    isAdmin: () => {
        // let user = this.getUser()
        let userString = localStorage.getItem("user")
        if (typeof (userString) == "undefined") return false;
        if (userString === false) return false;
        let user = JSON.parse(userString)


        if(user && user.role=='admin'){
            return true;
        }
        return false;
    },
    getUser: () => {
        let userString = localStorage.getItem("user")
        if (typeof (userString) == "undefined") return false;
        if (userString === false) return false;
        return  JSON.parse(userString)
    },
    getPromoter: () => {
        let promoterString = localStorage.getItem("promoter")
        if (typeof (promoterString) == "undefined") return false;
        if (promoterString === false) return false;
        return  JSON.parse(promoterString)
    },
    getKunde: () => {
        let kundenString = localStorage.getItem("kunde")
        if (typeof (kundenString) == "undefined") return false;
        if (kundenString === false) return false;
        return  JSON.parse(kundenString)
    },
    isLoggedIn: () => {
        let userString = localStorage.getItem("user")
        if (typeof (userString) == "undefined") return false;
        if (userString === false) return false;
        let user = JSON.parse(userString)
        if (user !== null && typeof (user) != "undefined") {
            return true;
        }
        return false;
    },
    promoterIsLoggedIn: () => {
        let promoterString = localStorage.getItem("promoter")
        if (typeof (promoterString) == "undefined") return false;
        if (promoterString === false) return false;
        let promoter = JSON.parse(promoterString)
        if (promoter !== null && typeof (promoter) != "undefined") {
            return true;
        }
        return false;
    },
    kundeIsLoggedIn: () => {
        let kundeString = localStorage.getItem("kunde")
        if (typeof (kundeString) == "undefined") return false;
        if (kundeString === false) return false;
        let kunde = JSON.parse(kundeString)
        if (kunde !== null && typeof (kunde) != "undefined") {
            return true;
        }
        return false;
    },
    getGermanDateTime: function (value) {

        if (value) {
            return moment(String(value)).format('DD.MM.YYYY HH:mm')
        }
    },
    getGermanDate: function (value) {
        if (value) {
            return moment(String(value)).format('DD.MM.YYYY')
        }
    },
    getEnglishDate: function (value) {
        if (value) {
            let array = value.split(".") // 01.12.2022
            return array[2]+"-"+array[1]+"-"+array[0]
        }
    },
    getGermanDateForEnglishDate: function (value) {
        // value="2020-01-02"
        if (value) {
            var x = value.split("-")
            return x[2] + "." + x[1] + "." + x[0]

        }
    },

    isNumber: function (n) {
        return !isNaN(parseFloat(n)) && isFinite(n);
      },


    getWochentagByIndex:function(index){
        // moment().day() 1 = Montag
        let days = ['Montag','Dienstag','Mittwoch','Donnerstag','Freitag','Samstag','Sonntag']
        return days[index-1];
    },
    goTo:function(path){
        console.log('path',path)


        console.log('router',this.router)

        if(this.router==null){
            this.router = useRouter();
        }
        if(typeof(this.router)!=="undefined"){

            this.router.push( path)
        }
    },

    prepareObject: function (obj) {

        for (var property in obj) {
            // console.log("--------------: "+ property + "   " + obj[property]);

            if (typeof obj[property] == "object") {
                this.prepareObject(obj[property]);
            }

            if (property == "created" && typeof obj[property] == "string") {
                obj[property] = moment(obj[property]).toDate();
            }
        }
    },
    dateToString:function(datum){

        if(typeof(datum)=="undefined"){
            return ""
        }

        return  moment(datum).format("DD.MM.YYYY HH:mm")
       },
    formatDate:function(){

     return  new Intl.DateTimeFormat("default", {
            dateStyle: "long",
        });
    },
    formatCurrency:function(){

        return  new Intl.NumberFormat("de-De", {
            style: "currency",
            currency: "EUR",
          });
       },

    euro:function(value){
        if(isNaN(value)){
            return "-"

        }

        return  new Intl.NumberFormat("de-De", {
        style: "currency",
        currency: "EUR",
        }).format(value);
    },
    zweistellig:function(value){
        if(isNaN(value)){
            return "-"

        }

        return  new Intl.NumberFormat("de-De", {
        style: "decimal",
        maximumFractionDigits:2,
        }).format(value);
    },
    shortenText:function(str,n){
        return (str.length > n) ? str.substr(0, n-1) + '...' : str;

    },
    shortenFirstWord:function(nameString){
        if(nameString.trim()=="") return nameString
        let x=nameString.split(" ");
        if(x.length==1) return nameString;

        const fullName = nameString.split(' ');
        const initials = fullName.shift().charAt(0) +". " + fullName.join(" ")
        return initials;


    },
    getDatumForKW: function (w, y) {
        var simple = new Date(y, 0, 1 + (w - 1) * 7);
        var dow = simple.getDay();
        var ISOweekStart = simple;
        if (dow <= 4)
            ISOweekStart.setDate(simple.getDate() - simple.getDay() + 1);
        else
            ISOweekStart.setDate(simple.getDate() + 8 - simple.getDay());
        return ISOweekStart;
    }

,
generatePW:function() {
    var pass = '';
    var str = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ' +
            'abcdefghijklmnopqrstuvwxyz0123456789@#$';

    for (let i = 1; i <= 8; i++) {
        var char = Math.floor(Math.random()
                    * str.length + 1);

        pass += str.charAt(char)
    }

    return pass;
},
 ucFirst:function(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  },


  isOverlapping:function(array,variante){

    array = array.filter((el) => el.variante==variante)


    for (let i = 0; i < array.length; i++) {
        const elementa = array[i];
        for (let j = 0; j < array.length; j++) {
            const elementb = array[j];

            if(elementa==elementb){
                console.log("A=B")
                continue;
            }

            if(elementa.von <= elementb.bis && elementa.bis >= elementb.von){
                return [elementa, elementb]
                return true;
            }

        }

    }

    return false;


  },

  getTobeDefined(){
    return  {
      "name": "Tobe Defined",
      "id_user": "6204d393db7f49b689d1c133"
    }
  },
  getClassForEinsatz:function(einsatz) {
    // console.log("getClassForEinsatz statusS",einsatz.stammdaten.status)
    // console.log("getClassForEinsatz typ",einsatz.stammdaten.typ)
    // console.log("einsatz.is_rsa_einsatz",einsatz.is_rsa_einsatz)

    if(einsatz.is_rsa_einsatz===true){

        return "einsatz_rsa"
      }


  if (einsatz.stammdaten.promoter.name == "Tobe Defined") {
    return "isTobeDefined";
  }
  if (einsatz.stammdaten.typ == "ausfall") {
    return "einsatz_ausfall";
  }

  switch (einsatz.stammdaten.status) {
    case "neu":
      return "einsatz_neu";
    case "zugesagt":
      return "einsatz_zugesagt";
    case "abgesagt":
      return "einsatz_abgesagt";
    default:
      return "einsatz_neu";
  }
},
isNumeric: function (n) {
    return !isNaN(parseFloat(n)) && isFinite(n);
  },

}
